export default __webpack_public_path__ + "static/N0058-23149e8baa57380abbc72c58ec883b54.png";